window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html: $('html'),
    $body: $('body'),

    // Navigation
    $navigation: $('#accessibleNav'),

    // Product Page
    $mainImage: $('#productPhotoImg'),
    $thumbImages: $('#productThumbs').find('a.product-photo-thumb'),
    newImage: null
  }
}

timber.init = function () {
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.productImageSwitch();
  timber.firefoxdetect();
}

timber.firefoxdetect = function () {
  if($.browser.mozilla){
  	$('body').addClass('ff');
  }
};



timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav--dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul');
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav--dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if ( !isSubItem ) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
}

timber.productImageSwitch = function () {
  if ( !timber.cache.$thumbImages.length ) {
    return;
  }

  // Switch the main image with one of the thumbnails
  // Note: this does not change the variant selected, just the image
  timber.cache.$thumbImages.on('click', function(e) {
    e.preventDefault();
    timber.cache.newImage = $(this).attr('href');
    timber.cache.$mainImage.attr({ src: timber.cache.newImage });
  });
}

// Initialize Timber's JS on docready
$(timber.init)



// Mobile Nav Change

$(function(){
      // bind change event to select
      $('.mobNav').bind('change', function () {
          var url = $(this).val(); // get selected value
          if (url) { // require a URL
              window.location = url; // redirect
          }
          return false;
      });
 });

// Fade products in on load

jQuery(document).ready(function() {
  
    jQuery('.prodGrid .grid-item').addClass("animhidden").viewportChecker({
        classToAdd: 'visible animated fadeIn',
        offset: 100
       });
  
  	jQuery('.header-logo').addClass("animhidden").viewportChecker({
        classToAdd: 'visible animated fadeIn',
        offset: 100
       });
  
});

// lightbox
$(function(){$('[rel="lightbox"]').lightbox({ nav:true});});

//Match height


$(window).load(function() {
  setTimeout(function(){
    $('.product-grid-image').matchHeight();
  }, 500);
});


//Sticky Header

$(document).ready(function(){
    $(".topbar").sticky({topSpacing:0});
  });


